<template>
  <el-tab-pane :label="label" :disabled="disabled" :name="name" :closable="closable" :lazy="lazy">
    <template v-if="(slots['label'])" #label>
      <slot name="label"></slot>
    </template>
    <slot></slot>
  </el-tab-pane>
</template>

<script lang="ts" setup>
import type { TabPaneProps } from './tab-pane'
import { ElTabPane } from 'element-plus'
import { useSlots } from 'vue'

defineOptions({
  name: 'OTabPane',
  inheritAttrs: false
})
const slots = useSlots()

const { label = '', disabled = false, name, closable = false, lazy = false } = defineProps<TabPaneProps>()
</script>